function CourseController(){
	this.className	= "CourseController";
	this.glob		= "/course/**";
	this.debug		= false;
};
CourseController.inheritsFrom( StandardController );
CourseController.prototype.setupPage = function(){
	console.log("CourseController: setupPage called");
};
CourseController.prototype.swap = function(){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");
};
CourseController.prototype.on = function(){
  this.header = $('header');
  this.footer = $('footer');
  this.header.hide();
  this.footer.hide();
};
CourseController.prototype.off = function(){
};